import { createReducer } from 'src/utils/reducer'
import * as actions from 'src/constants/actionTypes'
import { OWNERS_URL } from 'src/constants/urls'
import { LOCATION_CHANGE } from 'connected-react-router'
import controls, {
    initialControlsState,
    TOGGLE_CONTROL,
    SET_SINGLE_OPEN_ACTION,
    OPEN_CONTACT_SEARCH,
    CLOSE_CONTACT_SEARCH,
} from './controls'

const initialRunbookUiState = {
    organizationOptions: [],
    organizationsLoading: false,
    contactOptions: [],
    contactsQuery: '',
    contactsLoading: false,
    devices: [],
    deviceQuery: '',
    devicesLoading: false,
    runbookLoading: false,
    activeRunbook: null,
    controls: initialControlsState,
    focusedAction: null,
}

export const setActiveRunbook = (runbookId) => ({
    type: actions.SET_ACTIVE_RUNBOOK,
    runbookId,
})

const genericControlsAction = (state, action) => {
    return { ...state, controls: controls(state.controls, action) }
}

export default createReducer(initialRunbookUiState, {
    [actions.UPDATE_ACTION]: (state) => ({
        ...state,
        actionsSearch: '',
        selectedSibling: null,
    }),
    [actions.SET_ACTIVE_RUNBOOK]: (state, action) => {
        return {
            ...state,
            activeRunbook: action.runbookId,
            controls: {
                ...state.controls,
                selectedWindow: 'actions-list',
            },
        }
    },
    [actions.REFRESH_SOLUTION]: (state) => ({
        ...state,
        runbookLoading: true,
    }),
    [actions.REFRESH_SOLUTION_SUCCESS]: (state) => ({
        ...state,
        runbookLoading: false,
    }),
    [actions.REFRESH_SOLUTION_ERROR]: (state) => ({
        ...state,
        runbookLoading: false,
    }),
    [TOGGLE_CONTROL]: genericControlsAction,
    [SET_SINGLE_OPEN_ACTION]: genericControlsAction,
    [OPEN_CONTACT_SEARCH]: genericControlsAction,
    [CLOSE_CONTACT_SEARCH]: genericControlsAction,
    [actions.DELETE_ACTION]: genericControlsAction,
    [actions.SELECT_RUNBOOK_WINDOW]: genericControlsAction,
    [actions.END_RUNBOOK_SESSION]: genericControlsAction,
    [actions.EXPORT_RUNBOOK]: (state) => ({
        ...state,
        runbookLoading: false,
    }),
    [actions.EXPORT_HISTORY_LOGS]: (state) => ({
        ...state,
        runbookLoading: false,
    }),
    [actions.EXPORT_COMMENT_LOGS]: (state) => ({
        ...state,
        runbookLoading: false,
    }),
    [actions.EXPORT_ISSUE_LOGS]: (state) => ({
        ...state,
        runbookLoading: false,
    }),
    [actions.EXPORT_DECISION_LOGS]: (state) => ({
        ...state,
        runbookLoading: false,
    }),
    [actions.EXPORT_ACTIVITIES_LOGS]: (state) => ({
        ...state,
        runbookLoading: false,
    }),
    [actions.DELETE_ACTION_START]: (state) => ({
        ...state,
        runbookLoading: true,
    }),
    [actions.DELETE_ACTION_END]: (state) => ({
        ...state,
        runbookLoading: false,
    }),
    [actions.GET_RUNBOOK]: (state) => ({
        ...state,
        runbookLoading: true,
    }),
    [actions.GET_RUNBOOK_RECEIVED]: (state) => ({
        ...state,
        runbookLoading: false,
    }),
    [actions.GET_RUNBOOK_ERROR]: (state) => ({
        ...state,
        runbookLoading: false,
    }),
    [actions.CREATE_RUNBOOK]: (state) => ({
        ...state,
        runbookLoading: true,
    }),
    [actions.GET_RUNBOOK_RECEIVED]: (state) => ({
        ...state,
        runbookLoading: false,
    }),
    [actions.SET_SELECTED_ACTION_ID]: (state, action) => ({
        ...state,
        actionId: action.id,
    }),
    [actions.GENERATE_RUNBOOK_CSV_SUCCESS]: (state) => ({
        ...state,
        runbookLoading: false,
    }),
    [actions.UPDATE_RUNBOOK_SERVER]: (state, action) => {
        return {
            ...state,
            runbookLoading: true,
        }
    },
    [actions.UPDATE_RUNBOOK_SERVER_RECEIVED]: (state, action) => ({
        ...state,
        runbookLoading: false,
    }),
    [actions.UPDATE_RUNBOOK_SESSION_ACTIONS]: (state, action) => ({
        ...state,
    }),
    [actions.UPDATE_RUNBOOK_SESSION_ACTIONS_RECEIVED]: (state, action) => ({
        ...state,
    }),
    [actions.EDIT_RUNBOOK_ACTIONS]: (state, action) => {
        return {
            ...state,
            runbookLoading: true,
        }
    },
    [actions.EDIT_RUNBOOK_ACTIONS_RECEIVED]: (state, action) => ({
        ...state,
        runbookLoading: false,
    }),
    [actions.COPY_RUNBOOK_SERVER]: (state, action) => {
        return {
            ...state,
            runbookLoading: true,
        }
    },
    [actions.COPY_RUNBOOK_SERVER_RECEIVED]: (state, action) => ({
        ...state,
        runbookLoading: false,
    }),
    [actions.GET_CUSTOMER_SOLUTIONS_RUNBOOK]: (state) => ({
        ...state,
        runbookLoading: true,
    }),
    [actions.GET_CUSTOMER_SOLUTIONS_RUNBOOK_SUCCESS]: (state) => ({
        ...state,
        runbookLoading: false,
    }),
    [actions.GENERATE_RUNBOOK_CSV_SUCCESS]: (state) => ({
        ...state,
        runbookLoading: false,
    }),
    [actions.GET_OWNER_RESULTS]: (state) => ({
        ...state,
        contactsLoading: true,
    }),
    [actions.GET_OWNER_RESULTS_SUCCESS]: (state, action) => {
        return {
            ...state,
            contactsLoading: false,
            contactOptions: [...action.payload.data.results],
        }
    },
    [LOCATION_CHANGE]: genericControlsAction,
    [actions.SAVE_SUPPLIER_SUCCESS]: genericControlsAction,
    [actions.FOCUS_ACTION]: (state, action) => {
        return {
            ...state,
            focusedAction: action.actionId,
        }
    },
    CLEAR_FOCUSED_ACTION: (state) => {
        return { ...state, focusedAction: null }
    },
})

export const searchOwners = (query) => (dispatch, getState) => {
    const state = getState()
    const userOnly = state.ui.runbook.controls.isChangingOwnerUserOnly
    const userOnlyString = userOnly ? `?${userOnly}` : ''
    const url = `${OWNERS_URL}${query ? query + '/' : ''}${userOnlyString}`
    return dispatch({
        type: actions.API,
        method: 'get',
        payload: {
            url,
            start: () => ({ type: actions.GET_OWNER_RESULTS }),
            success: (payload) => {
                return {
                    type: actions.GET_OWNER_RESULTS_SUCCESS,
                    payload,
                }
            },
            error: (error) => ({
                type: actions.GET_OWNER_RESULTS_ERROR,
                error,
            }),
        },
        debounce: {
            key: 'searchOwners',
            wait: 500,
        },
    })
}

export const clearFocusedAction = () => ({
    type: 'CLEAR_FOCUSED_ACTION',
})
